import React from "react";
import { Quote, Star } from "lucide-react";

const TESTIMONIALS = [
  {
    quote:
      "I have used Lutrom Engineering Ltd for several years now, and I can recommend them for mechanical, electrical or fabrication. They have provided excellent service.",
    name: "Eric Whittaker",
    role: "Engineering Manager",
    headline: "EXCELLENT SERVICE",
  },
  {
    quote:
      "We have been using Lutrom Engineering for some time now and they're our primary engineering support. Lutrom has been responsible for installing new machinery, commissioning production lines, carrying out extensive preventative maintenance and reacting quickly to our machinery breakdowns. I've been very happy with their quality of work both mechanically and electrically and would have no problem in recommending them.",
    name: "Michael Lowde",
    role: "Managing Director",
    headline: "OUR PRIMARY ENGINEERING SUPPORT",
  },
];

const Stars = () => (
  <div
    className="flex items-center gap-1.5"
    aria-label="Five star rating"
    role="img"
  >
    {Array.from({ length: 5 }).map((_, i) => (
      <Star
        key={i}
        size={16}
        fill="#4f86ff"
        stroke="none"
        style={{ filter: "drop-shadow(0 0 6px rgba(79,134,255,0.55))" }}
      />
    ))}
  </div>
);

const Testimonials = () => {
  return (
    <section
      className="relative mt-24 lg:mt-32"
      id="testimonials"
      data-testid="testimonials-section"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-10">
        <div className="max-w-2xl mb-12">
          <p className="eyebrow">What clients say</p>
          <h2
            className="font-display mt-5 text-white"
            style={{ fontSize: "clamp(36px, 5vw, 60px)", lineHeight: 0.95 }}
          >
            TRUSTED BY THE
            <br />
            <span className="gradient-blue-text">PEOPLE WHO RUN PLANT.</span>
          </h2>
          <p className="mt-5 text-[15px] leading-relaxed text-[color:var(--lt-text-dim)]">
            Direct, unedited words from operations leaders we've supported across
            mechanical, electrical and commissioning work.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {TESTIMONIALS.map((t, i) => (
            <figure
              key={t.name}
              className="service-card rounded-2xl p-7 lg:p-9 relative"
              data-testid={`testimonial-${i}`}
            >
              <Quote
                size={48}
                className="absolute"
                style={{
                  top: 22,
                  right: 22,
                  color: "rgba(127, 166, 255, 0.18)",
                }}
                aria-hidden="true"
              />
              <div className="flex items-center justify-between gap-4 mb-5">
                <p
                  className="font-display text-white"
                  style={{
                    fontSize: 20,
                    letterSpacing: "0.04em",
                  }}
                >
                  {t.headline}
                </p>
                <Stars />
              </div>
              <blockquote className="text-[15px] leading-relaxed text-[color:var(--lt-text)]">
                <span className="text-[color:var(--lt-blue-soft)]">“</span>
                {t.quote}
                <span className="text-[color:var(--lt-blue-soft)]">”</span>
              </blockquote>
              <figcaption className="mt-7 flex items-center gap-4">
                <div
                  className="flex items-center justify-center font-display"
                  style={{
                    width: 44,
                    height: 44,
                    borderRadius: 12,
                    background:
                      "linear-gradient(180deg, rgba(47, 107, 255, 0.22), rgba(47, 107, 255, 0.06))",
                    border: "1px solid rgba(127, 166, 255, 0.35)",
                    color: "var(--lt-blue-soft)",
                    fontSize: 16,
                    letterSpacing: "0.05em",
                  }}
                  aria-hidden="true"
                >
                  {t.name
                    .split(" ")
                    .map((n) => n[0])
                    .slice(0, 2)
                    .join("")}
                </div>
                <div>
                  <p className="text-white font-semibold text-sm">{t.name}</p>
                  <p className="text-xs uppercase tracking-widest text-[color:var(--lt-text-dim)] mt-0.5">
                    {t.role}
                  </p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
